// src/contexts/PropertyContext.js
import React, { createContext, useState } from 'react';

export const PropertyContext = createContext();

export const PropertyProvider = ({ children }) => {
  const [selectedProperty, setSelectedProperty] = useState(() => {
    // Initialize from localStorage if available
    const savedProperty = localStorage.getItem('selectedProperty');
    return savedProperty || null;
  });

  return (
    <PropertyContext.Provider value={{ selectedProperty, setSelectedProperty }}>
      {children}
    </PropertyContext.Provider>
  );
};
